import { useEffect } from 'react';
import './about-page.scss';
import photo from '../../Assets/portfolio-portrait.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import Codewars from '../../Assets/Codewars.svg';
import LinkedIn from '../../Assets/LinkedIn.svg';

function AboutPage() {
	useEffect(() => {
		//preload images in this function
	}, []);

	return (
		<div className="AboutPageOuterContainer" id="about">
			<div className="AboutPageHeader">
				<h1>About Me</h1>
			</div>
			<div className="AboutPageContent">
				<div className="AboutPageImage">
					<img src={photo} alt="Portrait of myself" />
				</div>
				<div className="AboutPagePersonalDescription">
					<p>
						Hello I'm Mitchell and I'm a Software Developer based in Lancaster.
						With over 4 years of experience in C#, .NET,
						Angular, ReactJS, VueJS and Azure. My journey began with a big focus on
						backend development using ASP.NET MVC which then led to creating API
						serverless functions with Azure function apps. I have always had a
						passion for backend development including CI/CD integration with the
						cloud.
					</p>
					<p>
						I am always wanting to learn more and more with new technologies.
						I first set myself the challenge of creating my portfolio with
						ReactJS to learn the basics.
					</p>
					<ul>
						<li>
							<a href="https://github.com/MChapman1998">
								<FontAwesomeIcon icon={faGithub} />
							</a>
						</li>
						<li>
							<a href="https://www.linkedin.com/in/mitch-chapman/">
								<img src={LinkedIn} alt="LinkedIn" />
							</a>
						</li>
						<li>
							<a href="https://www.codewars.com/users/MChapman1998">
								<img src={Codewars} alt="LinkedIn" />
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}

export default AboutPage;
